export enum SearchType {
    QUICK_SEARCH = 'quickSearch',
    ADVANCED_SEARCH = 'advancedSearch',
    NAVIGATION_SEARCH = 'navigationSearch',
    FILTERS_SEARCH = 'filtersSearch'
}
